export function anchorButtonScroll(): void {
  const anchorButton = document.querySelector('.go-to-anchor-button');
  if (!anchorButton) return;

  anchorButton.addEventListener('click', (event: Event) => {
    const targetElement = document.getElementById('nav-benefits');
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', anchorButtonScroll);
} else {
  anchorButtonScroll();
}
